import React from 'react';
import { ShowButton } from 'admin-on-rest';

const ShowButtonWithPermission = ({ resource, path, permissions, ...props }) => (
  permissions.show ? <ShowButton {...props} resource={resource} basePath={path || props.basePath} /> : null
);

export default ShowButtonWithPermission;
